import { render, staticRenderFns } from "./MsgeifVcDemo.vue?vue&type=template&id=0cf537e5&scoped=true&"
import script from "./MsgeifVcDemo.vue?vue&type=script&lang=js&"
export * from "./MsgeifVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./MsgeifVcDemo.vue?vue&type=style&index=0&id=0cf537e5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf537e5",
  null
  
)

export default component.exports